import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import DidYouMeanModalResult from './DidYouMeanModalResult';

export default class DidYouMeanModal extends Component {
    static propTypes = {
        className: PropTypes.string,
        results: PropTypes.array.isRequired,
        onHidden: PropTypes.func.isRequired
    };

    _onResultSelected = result => {
        this._modal.hide(result);
    }

    render() {
        const {
            className,
            results,
            onHidden
        } = this.props;
        const classes = classNames(
            'DidYouMeanModal',
            className
        );
        const hasResults = (results.length > 0);
        const title = (hasResults) ? 'Multiple Addresses Found' : 'No Address Found';

        return (
            <Modal
                ref={node => { this._modal = node; }}
                className={classes}
                title={title}
                onHidden={onHidden}
            >
                <ModalContent>
                    {!hasResults &&
                        <p>Please try again using a different address.</p>
                    }
                    {hasResults &&
                        <Fragment>
                            <h2 className="heading-md">Which one do you want?</h2>
                            <div className="DidYouMeanModal-row">
                                {results.map(result => {
                                    return (
                                        <DidYouMeanModalResult
                                            key={result.search_string}
                                            result={result}
                                            onResultSelected={this._onResultSelected}
                                        />
                                    );
                                })}
                            </div>
                        </Fragment>
                    }
                </ModalContent>
            </Modal>
        );
    }
}
